import { ReasonCategory, RefundSelectedReasonState, VoluntaryReason } from '../types';
import { ActionSelectedReasonTypes, SET_SELECTED_REASON } from './actions';

const initialState: RefundSelectedReasonState = {
	category: ReasonCategory.Voluntary,
	reason: VoluntaryReason.PlansChanged,
	docs: []
};

function selectedReasonsReducer(state = initialState, { type, payload }: ActionSelectedReasonTypes) {
	switch (type) {
		case SET_SELECTED_REASON:
			return payload;
		default:
			return state;
	}
}

export default selectedReasonsReducer;
